import React, {Component} from "react";
import {connect} from "react-redux";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import PanelLayout from "../components/PanelLayout";
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";
import InputWithLabel from "../components/InputWithLabel";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import MultiplePropertyContent from "../components/MultiplePropertyContent";
import MaterialIcon from "../../MaterialIcon";
import axios from "axios";
import axiosConfig from "../../../utils/axiosConfig";
import messageCodes from "../../../utils/messageCodes";

class LogicToContextPanel extends Component {
    constructor(props) {
        super(props);

        this.hasFuncs = this.props.clickedNodeInfo.extras.options
            && this.props.clickedNodeInfo.extras.options.logicToContextInfo
            && this.props.clickedNodeInfo.extras.options.logicToContextInfo.scenarioName;

        this.hasOptions = this.props.clickedNodeInfo.extras.options
            && this.props.clickedNodeInfo.extras.options.logicToContextInfo;

        this.hasPropertyDefinitions = this.hasOptions
            && this.props.clickedNodeInfo.extras.options.logicToContextInfo.propertyDefinitions;


        this.state = {
            propertyDefinitions: this.hasPropertyDefinitions ? this.props.clickedNodeInfo.extras.options.logicToContextInfo.propertyDefinitions : [],
            scenarioName: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.logicToContextInfo.scenarioName : "",
            logics: []
            // propertyName: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.logicToContextInfo.propertyName : "",
            // outputContextPropertyName: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.logicToContextInfo.outputContextPropertyName : ""
        }

        this.onPropertyChange = this.onPropertyChange.bind(this);
        this.onPropertyDefinitionUpdate = this.onPropertyDefinitionUpdate.bind(this);
        this.onDeleteProperty = this.onDeleteProperty.bind(this);
        this.onAddNewPropertyDefinition = this.onAddNewPropertyDefinition.bind(this);
        this.getLogicList = this.getLogicList.bind(this);
    }

    componentDidMount() {
        this.getLogicList();
    }

    getLogicList() {
        axios.get(this.props.properties.logicUrl, axiosConfig())
            .then((response) => {
                this.setState({
                    logics: response.data
                        .filter(logic => logic.id !== +window.location.href.split("/").slice(-3)[0])
                        .sort(
                            (a, b) => a.name > b.name ? 1 : -1
                        )
                });
            })
            .catch((err) => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                } else {
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            });
    }

    onPropertyChange(property, value) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let logicToContextInfo = Object.assign({}, clickedNodeInfo);

        logicToContextInfo.extras.options = {
            ...logicToContextInfo.extras.options,
            logicToContextInfo: {
                ...this.state,
                [property]: value
            }
        };

        this.setState({
            [property]: value
        });

        this.props.clickedNodeAction(logicToContextInfo);
    }

    onPropertyDefinitionUpdate(index, propertyName, value) {
        let propertyDefinitionsUpdate = this.state.propertyDefinitions;
        propertyDefinitionsUpdate[index][propertyName] = value;

        this.onPropertyChange("propertyDefinitions", propertyDefinitionsUpdate);
        // this.setState({
        //     "propertyDefinitions": propertyDefinitionsUpdate
        // }, () => this.onOptionsUpdate(propertyName, this.state[propertyName]));
    }

    onDeleteProperty(propertyName, index) {
        const propertyUpdate = this.state[propertyName].filter((value, _index) => _index !== index);
        this.setState({
            [propertyName]: propertyUpdate
        }, () => this.onOptionsUpdate(propertyName, this.state[propertyName]));
    }

    onOptionsUpdate(type, value) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let logicToContextInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(logicToContextInfo.extras, "options")) {
            logicToContextInfo.extras.options = {};
        }
        logicToContextInfo.extras.options = {
            ...logicToContextInfo.extras.options,
            logicToContextInfo: {
                ...logicToContextInfo.extras.options.logicToContextInfo,
                [type]: value
            }
        };

        this.props.clickedNodeAction(logicToContextInfo);
    }

    onAddNewPropertyDefinition() {
        this.setState(prevState => ({
            propertyDefinitions: [
                ...prevState.propertyDefinitions,
                {propertyName: "", outputContextPropertyName: ""}
            ]
        }), () => this.onOptionsUpdate("propertyDefinitions", this.state.propertyDefinitions));
    }

    openLogicInNewTab() {
        const url = "/logics/";
        const logicId = this.state.logics.find(logic => logic.name === this.state.scenarioName).id;
        window.open(url + logicId, '_blank', 'noopener,noreferrer');
    }


    render() {
        return (
            <PanelLayout>
                <ContentWithTopLabel label="Scenario">
                    <div className="select-open-logic">
                        <div className="form-select">
                            {!this.props.hideArrow &&
                                <span className="arrow"><MaterialIcon icon="keyboard_arrow_down"
                                                                        size={24}/></span>
                            }
                            <select onChange={(e) => this.onPropertyChange('scenarioName', e.target.value)}
                                    value={this.state.scenarioName}>
                                {this.state.scenarioName === "" ? <option value="" disabled>Choose logic...</option> : null}
                                {this.state.logics.length > 0 ?
                                    this.state.logics.map((x, y) =>
                                        <option key={y} value={x.name}>{x.name}</option>) :
                                    <option value="" disabled>There is no logics</option>
                                }
                            </select>
                        </div>
                        <div className="request-button">
                            <button className="action-button save-button" 
                                    onClick={() => this.openLogicInNewTab()}>
                                <span className="button-label">Open&nbsp;Logic</span>
                            </button>
                        </div>
                    </div>
                </ContentWithTopLabel>
                <MultiplePropertyContent label="Property definitions" onAddNew={this.onAddNewPropertyDefinition}>
                    {this.state.propertyDefinitions && this.state.propertyDefinitions.map((dynProp, index) => (
                        <div className="prop-row" key={index}>
                            <InputWithLabel label="Property name:"
                                handleChange={e => this.onPropertyDefinitionUpdate(index, 'propertyName', e.target.value)}
                                value={this.state.propertyDefinitions[index].propertyName}
                            />
                            <InputWithLabel label="Output context property name:"
                                handleChange={e => this.onPropertyDefinitionUpdate(index, 'outputContextPropertyName', e.target.value)}
                                value={this.state.propertyDefinitions[index].outputContextPropertyName}
                            />
                            <div className="close-button"
                                 onClick={() => this.onDeleteProperty("propertyDefinitions", index)}>
                                <MaterialIcon icon="remove_circle"/>
                            </div>
                        </div>
                    ))}
                </MultiplePropertyContent>
            </PanelLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {
    clickedNodeAction,
    showToastForFrontend,
    showToastForBackend
})(LogicToContextPanel);
